$(document).ready(function () {

    document.querySelectorAll('select[data-depends]').forEach((childSelect) => {
        let parentSelect = childSelect.form[childSelect.dataset.depends]; // parent <select>
        let url = childSelect.dataset.url; // attribute data-url
        let items = JSON.parse(childSelect.dataset.items || 'null'); // attribute data-items
        let disableEmpty = childSelect.dataset.disableempty; // attribute data-disableempty
        let disabled = childSelect.dataset.disabled; // attribute data-disabled
        let disabledItemIds = JSON.parse(childSelect.dataset.disableditemids || '[]'); // attribute data-disabledItemIds
        let selectedValue = JSON.parse(childSelect.dataset.selectedvalue || 'null'); // attribute data-selectedvalue
        let multiselect = childSelect.dataset.multiselect;

        // when the user changes the selected item in the parent selection...
        parentSelect.addEventListener('change', () => {
            if (items) {
                updateSelectbox(childSelect, items[parentSelect.value], disableEmpty, disabled, disabledItemIds, selectedValue, false, multiselect);
            }

            if (url) {
                fetch(url.replace(encodeURIComponent('#'), encodeURIComponent(parentSelect.value)))
                    .then((response) => response.json())
                    .then((data) => updateSelectbox(childSelect, data, disableEmpty, disabled, disabledItemIds, selectedValue, false, multiselect));
            }
        });

        updateSelectbox(childSelect, items[parentSelect.value], disableEmpty, disabled, disabledItemIds, selectedValue, true, multiselect); // fist call
    });

    // replaces <options> in <select>
    function updateSelectbox(select, items, disableEmpty, disabled, disabledItemIds, selectedValue, firstCall, multiselect) {
        select.innerHTML = ''; // remove all
        let selectedValueIndex = null;
        let selectedValuesArrayIndex = [];
        let itemIndex = 0
        for (let id in items) { // insert new
            let el = document.createElement('option');
            el.setAttribute('value', id);

            // check if the option id is in the disabledItemIds array, if so, make it disabled (non-selectable)
            if(disabledItemIds.length && disabledItemIds.includes(parseInt(id))){
                el.setAttribute('disabled', 'true');
            }

            el.innerText = items[id];
            select.appendChild(el);

            if(selectedValue && id.toString() === selectedValue.toString())
                selectedValueIndex = itemIndex;

            if (selectedValue && Array.isArray(selectedValue) && selectedValue.includes(parseInt(id)))
                selectedValuesArrayIndex.push(itemIndex);

            itemIndex++;
        }

        if (disableEmpty !== undefined) {
            if (items === undefined || items.length === 0) {
                select.setAttribute('disabled', 'disabled');
            } else {
                select.removeAttribute('disabled');
            }
        }

        if (disabled !== undefined) {
            select.setAttribute('disabled', 'disabled');
        }

        if (multiselect !== undefined) {
            if (selectedValuesArrayIndex.length) {
                selectedValuesArrayIndex.forEach(function(currentElement, index, array) {
                    select.options[currentElement].selected = true;
                });
            }
        } else {
            select.selectedIndex = selectedValueIndex ?? 0;
        }

        const event = new Event('change');
        select.dispatchEvent(event);
    }

});